<div class="customer-details-selector-root">
  <ng-container *ngFor="let element of selectorItems; let i = index">
      <app-quick-menu-item 
        icon="{{ element.icon }}" 
        (click)="showContent(element.text)"
        [active]="isActive(element.text)">
        {{ element.text | transloco }}
      </app-quick-menu-item>
    </ng-container >
</div>
